var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionTitleSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 121,
    viewBox: "0 0 296 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_198_1675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 104L134 16C118.5 47.3333 90.3 108.8 101.5 104C115.5 98 212.5 24.5 279.5 30.5",
    stroke: "#F6BEFF",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_198_1675",
    x: 0.9,
    y: 0.703283,
    width: 294.7,
    height: 119.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.05,
    result: "effect1_foregroundBlur_198_1675"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionTitleSvg);
export default __webpack_public_path__ + "static/media/section-title-svg.4d004a22d37a2b31adf6d911c1750a4f.svg";
export { ForwardRef as ReactComponent };